import { CSSProperties } from "react";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import * as typeStyles from "@clockwise/web-commons/src/styles/type.styles";

export const description: CSSProperties = {
  lineHeight: 1.2,
  fontSize: typeStyles.size.std,
  padding: spacing.std,
};

export const emphasized: CSSProperties = {
  fontWeight: "bold",
};
